export const timeFormat = (data) => {
    let date = new Date(data);
    // let Y = date.getFullYear() + '-';
    let M = (date.getMonth()+ 1  < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    let D = date.getDate() + ' ';
    let h = (date.getHours()  < 10 ? '0' + (date.getHours() ) : date.getHours() ) + ':';
    let m = (date.getMinutes()  < 10 ? '0' + (date.getMinutes() ) : date.getMinutes() ) ;
    // let s = date.getSeconds();
    // console.log(M + D + h + m + s);
    return ( M + D + h + m )
}

export const checkImgExists = (imgurl)=> {
    return new Promise(function (resolve, reject) {
      var ImgObj = new Image();
      ImgObj.src = imgurl;
      ImgObj.onload = function (res) {
        resolve(res);
      };
      ImgObj.onerror = function (err) {
        reject(err);
      };
    })
}